import React from 'react';
import { Modal } from '../ui';
import QuestionTypePicker from './QuestionTypePicker';
import { useBuilderEditor } from '../../features/builder/BuilderEditorContext';

const QuestionTypePickerModal = ({ onSelect }) => {
  const {
    showAnswerTypePicker,
    closeQuestionTypePicker,
    chooseAnswerType,
  } = useBuilderEditor();

  const handleSelect = (type) => {
    chooseAnswerType(type);
    onSelect?.(type);
  };

  if (!showAnswerTypePicker) return null;

  return (
    <Modal
      show={showAnswerTypePicker}
      onClose={closeQuestionTypePicker}
      title="Choose question type"
      size="lg"
    >
      <QuestionTypePicker onSelect={handleSelect} />
    </Modal>
  );
};

export default QuestionTypePickerModal;
